/*
 * COPYRIGHT © 2026 SANITÀNEXUS WHITE-LABEL. ALL RIGHTS RESERVED.
 * AUTHOR AND SOLE DEVELOPER: MARCO PANZETTI (C.F. PNZMRC89M14F251C)
 * Protected under Italian Copyright Law (Legge 633/1941) and International Treaties.
 * Unauthorized copying, reverse engineering, or distribution of this software architecture,
 * UI/UX layouts, local-first logic, or system prompt configurations is strictly prohibited.
 */
import React from 'react';
import { Receipt, UserPlus } from 'lucide-react';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Switch } from '@/components/ui/switch';
import { IseeTiersEditor } from '@/components/brand/IseeTiersEditor';

const PRICE_FIELDS = [['defaultVisitPrice', 'Prezzo visita default €'], ['doctorAnnualSubscription', 'Abbonamento medico €/anno'], ['patientPremiumMonthly', 'Premium paziente €/mese'], ['platformFeePct', 'Commissione piattaforma %'], ['freeConsultationsPerMonth', 'Consulti gratuiti / mese']];

/** Passo 4 — listino, fasce ISEE e primo amministratore. */
export const StepPricing = ({ pricing, onPricingChange, isee, onIseeChange, iseeEnabled, onIseeEnabledChange, admin, onAdminChange }) => (
  <div className="space-y-5 animate-fade-slide" data-testid="setup-panel-pricing">
    <div>
      <h2 className="font-display font-semibold text-lg flex items-center gap-2"><Receipt className="h-5 w-5 text-primary" /> Listino e scaglioni ISEE</h2>
      <p className="text-sm text-muted-foreground">Variabili di business centralizzate in <span className="font-mono">brand-config.json → priceList / iseeTiers</span>.</p>
    </div>
    <div className="grid gap-3 sm:grid-cols-3">
      {PRICE_FIELDS.map(([k, l]) => (
        <div key={k}><Label className="text-xs">{l}</Label><Input type="number" step="0.01" min={0} value={pricing[k]} onChange={(e) => onPricingChange({ ...pricing, [k]: e.target.value })} className="h-11 rounded-xl" data-testid={`setup-price-${k}`} /></div>
      ))}
    </div>
    <div className="rounded-xl border border-border/70 p-3 space-y-3">
      <div className="flex items-center justify-between"><span className="text-sm font-semibold">Sconti automatici per fascia ISEE</span><Switch checked={iseeEnabled} onCheckedChange={onIseeEnabledChange} data-testid="setup-isee-toggle" /></div>
      {iseeEnabled && <IseeTiersEditor tiers={isee} onChange={onIseeChange} compact testIdPrefix="setup-isee" />}
    </div>
    <div className="rounded-xl border border-border/70 p-3 space-y-3">
      <div className="text-sm font-semibold flex items-center gap-2"><UserPlus className="h-4 w-4 text-primary" /> Primo amministratore (opzionale)</div>
      <div className="grid gap-2 sm:grid-cols-3">
        <Input placeholder="Nome e cognome" value={admin.full_name} onChange={(e) => onAdminChange({ ...admin, full_name: e.target.value })} className="h-10 rounded-lg" data-testid="setup-admin-name" />
        <Input type="email" placeholder="email@clinica.it" value={admin.email} onChange={(e) => onAdminChange({ ...admin, email: e.target.value })} className="h-10 rounded-lg" data-testid="setup-admin-email" />
        <Input type="password" placeholder="password (min 10)" value={admin.password} onChange={(e) => onAdminChange({ ...admin, password: e.target.value })} className="h-10 rounded-lg" data-testid="setup-admin-password" />
      </div>
    </div>
  </div>
);
